import { KeyValue } from "@/main/models/common";

export enum VoucherTypeTypes {
	GET_VOUCHER_TYPE = "@voucherType/GET_VOUCHER_TYPE",
	SAVE_VOUCHER_TYPE = "@voucherType/SAVE_VOUCHER_TYPE",
	RESET_REDUCER_VOUCHER_TYPE = "@voucherType/RESET_REDUCER_VOUCHER_TYPE",
}

export interface VoucherTypeState {
	readonly voucherType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetVoucherType {
	type: typeof VoucherTypeTypes.GET_VOUCHER_TYPE;
}

export interface SaveVoucherType {
	type: typeof VoucherTypeTypes.SAVE_VOUCHER_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerVoucherType {
	type: typeof VoucherTypeTypes.RESET_REDUCER_VOUCHER_TYPE;
}

export type VoucherTypeActionTypes = GetVoucherType | SaveVoucherType | ResetReducerVoucherType;
